<hvl-form-item [formGroup]="formGroup" label="{{ label | translate }}" key="{{ name }}">
    <p-inputNumber [id]="inputId" [name]="name" [formControlName]="name" [min]="min" [max]="max"></p-inputNumber>
</hvl-form-item>
